export const formatPhoneNumber = (phoneNumber) => {
  const match = phoneNumber?.replace(/\D/g, '')?.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `+1 ${match[2]}-${match[3]}-${match[4]}`;
  }

  return phoneNumber;
};
